<template>
  <Head :title="course.name" />
  <div class="flex h-full w-full justify-center">
    <div class="h-full relative w-full lg:w-5/7">
      <div
        class="overflow-y-auto h-full w-full absolute bg-gray-100 py-12 px-4 xs:px-12"
      >
        <div class="mb-4 flex max-w-3xl justify-start flex-col">
          <h1 class="text-2xl font-bold">
            {{ course.name }}
          </h1>
          <div class="mt-2">
            <CourseTypeTag :type="course.type" />
          </div>
        </div>
        <div
          class="flex flex-col md:flex-row gap-1 md:gap-0 items-center py-3"
          :class="{ hidden: completed === null }"
        >
          <ProgressBar
            class="grow bg-white h-3 w-full md:w-auto"
            :value="completed"
            :show-value="false"
            pt:value:class="bg-secondary-color"
          />
          <span
            class="w-fit ml-5 mr-1 text-secondary-color font-semibold text-sm md:text-base self-end"
            >{{ completed + '% complete' }}</span
          >
        </div>
        <div class="flex flex-row mb-1 mt-8">
          <h1 class="text-xl">STRUCTURA:</h1>
        </div>
        <div class="">
          <Panel
            v-for="chapter_id in course.ordered_chapter_ids"
            :key="chapter_id"
            :header="course.chapters[chapter_id].name"
            toggleable
            pt:root:class="bg-gray-100 border-gray-400"
            pt:header:class="text-lg sm:text-xl"
            class="mt-4"
          >
            <Link
              v-for="(subject_id, indexS) in course.chapters[chapter_id]
                .ordered_subjects_ids"
              :key="subject_id"
              :href="$routes.subject(subject_id)"
              class="rounded-md flex flex-row mt-3 bg-white p-3 sm:p-5 text-md sm:text-lg pointer items-center"
            >
              <template
                v-if="
                  course.chapters[chapter_id].subjects[subject_id].type ===
                  'VideoSubject'
                "
              >
                <i
                  v-if="marked.includes(subject_id)"
                  class="pi pi-check-circle mr-2 text-secondary-color text-2xl"
                ></i>
                <i v-else class="pi pi-circle mr-2 text-gray-500 text-2xl"></i>
              </template>
              <template
                v-else-if="
                  course.chapters[chapter_id].subjects[subject_id].type ===
                  'FeedbackSubject'
                "
              >
                <i class="pi pi-cloud-upload mr-2 text-black text-2xl"></i>
              </template>
              <template
                v-else-if="
                  course.chapters[chapter_id].subjects[subject_id].type ===
                  'QuizSubject'
                "
              >
                <i class="pi pi-question-circle mr-2 text-black text-2xl"></i>
              </template>
              <template v-else>
                <i class="pi pi-file mr-2 text-black text-2xl"></i
              ></template>
              {{
                indexS +
                1 +
                '. ' +
                course.chapters[chapter_id].subjects[subject_id].name
              }}
            </Link>
          </Panel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3';
import Layout from '@/Layouts/Main.vue';
import ProgressBar from 'primevue/progressbar';
import CourseTypeTag from '@/Shared/CourseTypeTag.vue';
import Panel from 'primevue/panel';

export default {
  components: {
    Head,
    Link,
    ProgressBar,
    CourseTypeTag,
    Panel,
  },
  layout: Layout,
  props: {
    course: {
      type: Object,
      required: true,
    },
    marked: {
      type: Array,
      required: true,
    },
    completed: {
      type: Number,
      required: true,
    },
  },
};
</script>
